import script from "./DialogHusbandry.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogHusbandry.vue?vue&type=script&setup=true&lang=ts"

import "./DialogHusbandry.vue?vue&type=style&index=0&id=12f7d961&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12f7d961"]])

export default __exports__